<div class="card-body" *ngIf="loading">
  <div class="k-i-loading ml-1 mr-1" style="font-size: 40px;"></div>
</div>

<div *ngIf="empresa">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <ol class="breadcrumb m-0" *ngIf="modoSuperadmin">
            <li class="breadcrumb-item"><a routerLink="/superadmin/empresas">Empresas</a></li>
            <li class="breadcrumb-item active">{{empresa.nome}}</li>
          </ol>
          <ol class="breadcrumb m-0" *ngIf="!modoSuperadmin">
            <li class="breadcrumb-item"><a routerLink="/admin/loja">Loja</a></li>
            <li class="breadcrumb-item active">Números WhatsApp</li>
          </ol>
        </div>
        <h4 class="page-title">
          <button class="btn btn-outline-blue btn-rounded" (click)="voltar()">
            <i class="fa fa-arrow-left ct-point" ></i>
          </button>&nbsp;&nbsp;
          <i [ngClass]="modoSuperadmin ? 'far fa-building' : 'fab fa-whatsapp'"></i>
          <span *ngIf="modoSuperadmin"> {{empresa.nome}} </span>
          <span *ngIf="!modoSuperadmin"> Números WhatsApp </span>
        </h4>
      </div>
    </div>
  </div>

  <div class="alerta-sucesso" role="status" *ngIf="msgSucesso">
    <i class="mdi mdi-check-circle-outline"></i>
    <span>{{msgSucesso}}</span>
  </div>

  <div class="numeros-container">
    <!-- Barra de resumo: o que está valendo agora + ação principal -->
    <div class="resumo-bar">
      <div class="resumo-itens">
        <div class="resumo-item">
          <span class="resumo-rotulo">Números</span>
          <strong class="resumo-valor">{{objetos.length}}</strong>
        </div>
        <div class="resumo-item">
          <span class="resumo-rotulo">
            <i class="fas fa-crown"></i>
            Atendimento
          </span>
          <strong class="resumo-valor" *ngIf="numeroPrincipal?.whatsapp">{{numeroPrincipal.whatsapp | tel}}</strong>
          <strong class="resumo-valor resumo-valor-vazio" *ngIf="!numeroPrincipal?.whatsapp">Não definido</strong>
        </div>
        <div class="resumo-item">
          <span class="resumo-rotulo">
            <i class="fas fa-bullhorn"></i>
            Campanhas
          </span>
          <strong class="resumo-valor" *ngIf="numeroCampanhas?.whatsapp">{{numeroCampanhas.whatsapp | tel}}</strong>
          <strong class="resumo-valor resumo-valor-vazio" *ngIf="!numeroCampanhas?.whatsapp">Usa o principal</strong>
        </div>
      </div>

      <button class="btn-add-modern" (click)="novo()">
        <i class="fe-plus"></i>
        <span>Adicionar Número</span>
      </button>
    </div>

    <p class="orientacao-numeros" *ngIf="objetos.length > 0">
      <i class="fas fa-info-circle" aria-hidden="true"></i>
      Escolha a função de cada número. Com a nova extensão, a campanha pode sair aos poucos: um limite por dia, no horário que você definir.
    </p>
    <!-- Grid de números -->
    <div class="numeros-grid" *ngIf="objetos.length > 0">
      <div class="numero-card" *ngFor="let numero of objetos; trackBy: identifiqueNumero"
           [class.e-principal]="isPrincipal(numero)">
        <div class="card-header-modern">
          <div class="numero-info">
            <div class="numero-display">
              <i class="fab fa-whatsapp whatsapp-icon"></i>
              <span class="numero-text">{{numero.whatsapp | tel}}</span>
            </div>

            <!-- Só estados excepcionais viram badge; a função fica nos chips abaixo -->
            <div class="badges-container" *ngIf="numero.ocultar || (numero.versaoExtensao === 4 && numero.pausado)">
              <span *ngIf="numero.ocultar"
                    class="badge-modern badge-orange"
                    kendoTooltip
                    title="Este número não aparece no cardápio público para os clientes. É usado apenas internamente">
                <i class="fas fa-eye-slash"></i>Oculto no cardápio
              </span>
              <span *ngIf="numero.versaoExtensao === 4 && numero.pausado" class="badge-modern badge-red"
                    kendoTooltip title="Campanhas e fidelidade estão pausadas. Status do pedido e avaliações continuam.">
                <i class="fas fa-pause-circle"></i>Campanhas e fidelidade pausadas
              </span>
            </div>
          </div>

          <!-- Botões de ação -->
          <div class="action-buttons">
            <button class="btn-action btn-delete"
                    *ngIf="podeRemover(numero)"
                    (click)="abraDialogRemover(numero)"
                    kendoTooltip title="Remover número" aria-label="Remover número">
              <i class="fas fa-trash"></i>
            </button>
          </div>
        </div>

        <!-- Função do número: dois chips selecionáveis -->
        <div class="card-body-modern">
          <div class="funcoes">
            <span class="funcoes-rotulo">Usar este número para</span>
            <div class="funcoes-opcoes">
              <div class="funcao">
                <input id="principal{{numero.id}}" name="principal" type="radio"
                       kendoRadioButton class="funcao-input"
                       [(ngModel)]="numeroPrincipal.whatsapp"
                       [value]="numero.whatsapp"
                       (click)="mudarParaPrincipal(numero)"/>
                <label for="principal{{numero.id}}" class="funcao-chip funcao-chip-principal"
                       kendoTooltip title="Número usado no atendimento geral e no cardápio">
                  <i class="fas fa-crown"></i>
                  <span>Atendimento</span>
                  <i class="fas fa-check funcao-check"></i>
                </label>
              </div>

              <div class="funcao">
                <input id="campanhas{{numero.id}}" name="campanhas" type="radio"
                       kendoRadioButton class="funcao-input"
                       [(ngModel)]="campanhasRadioValue"
                       [value]="numero.whatsapp"
                       (click)="mudarParaCampanhas(numero)"/>
                <label for="campanhas{{numero.id}}" class="funcao-chip funcao-chip-campanhas"
                       kendoTooltip
                       [title]="isCampanhas(numero) ? 'Clique novamente para voltar a usar o número principal' : 'Clique para enviar as campanhas de marketing por este número'">
                  <i class="fas fa-bullhorn"></i>
                  <span>Campanhas</span>
                  <i class="fas fa-check funcao-check"></i>
                </label>
              </div>
            </div>
          </div>

          <div class="protecao">
            <div class="protecao-carregando" *ngIf="!numero.politicaCarregada && !numero.politicaErro">
              <span class="k-i-loading"></span>
              Carregando a configuração deste número...
            </div>

            <ng-container *ngIf="numero.politicaCarregada && numero.versaoExtensao === 4">
              <div class="limite-destaque">
                <div>
                  <span class="limite-rotulo">
                    <i class="fas fa-shield-alt" aria-hidden="true"></i>
                    Campanhas e fidelidade
                  </span>
                  <strong>{{numero.limiteDiario}}<em> mensagens / dia</em></strong>
                </div>

              </div>

              <p class="limite-compartilhado">Um único limite para os dois tipos de envio.</p>

              <div class="uso" *ngIf="numero.usadoHoje >= 0">
                <div class="uso-topo">
                  <span class="uso-rotulo">
                    <i class="fas fa-paper-plane" aria-hidden="true"></i>
                    Usadas hoje
                  </span>
                  <strong>{{numero.usadoHoje}}<em> de {{numero.limiteDiario}}</em></strong>
                </div>
                <div class="uso-barra">
                  <div class="uso-preenchido" [ngClass]="classeDeUso(numero)"
                       [style.width.%]="percentualUsado(numero)"></div>
                </div>
                <small class="uso-disponivel">{{numero.pausado ? 'Envios pausados' : numero.restanteHoje + ' disponíveis hoje'}}</small>
              </div>

              <div class="uso uso-indisponivel" *ngIf="!(numero.usadoHoje >= 0)">
                <small>Consumo de hoje indisponível</small>
              </div>

              <div class="risco-banimento" *ngIf="numero.limiteDiario > 100">
                <i class="fas fa-exclamation-triangle"></i>
                <span>
                  <strong>Risco de banimento.</strong>
                  Quanto mais mensagens, maior a chance de bloqueio ou banimento do número pelo WhatsApp. O limite e o intervalo não eliminam esse risco.
                </span>
              </div>

              <div class="incertas-hoje" *ngIf="numero.incertasHoje > 0">
                <i class="fas fa-exclamation-circle"></i>
                <span>
                  <strong>{{numero.incertasHoje}}</strong>
                  {{numero.incertasHoje === 1 ? 'envio precisa' : 'envios precisam'}} de conferência hoje.
                </span>
              </div>

              <div class="protecao-linhas">
                <div class="protecao-linha">
                  <span class="protecao-rotulo">
                    <i class="fas fa-bullhorn" aria-hidden="true"></i>
                    Campanhas
                  </span>
                  <strong>{{numero.pausado ? 'Pausadas' : 'Até 1 a cada ' + formateDuracao(numero.intervaloCampanhaSegundos)}}</strong>
                </div>
                <div class="protecao-linha">
                  <span class="protecao-rotulo">
                    <i class="fas fa-robot" aria-hidden="true"></i>
                    Fidelidade
                  </span>
                  <strong>{{numero.pausado ? 'Pausadas' : 'Até 1 a cada ' + formateDuracao(numero.intervaloAutomacaoSegundos)}}</strong>
                </div>
                <div class="protecao-linha protecao-linha-horario">
                  <span class="protecao-rotulo">
                    <i class="fas fa-clock" aria-hidden="true"></i>
                    Horário de campanhas e fidelidade
                  </span>
                  <strong>{{formateHorario(numero)}}</strong>
                  <small *ngIf="numero.capacidadeDiariaCalculada < numero.limiteDiario">
                    Esta janela comporta até {{numero.capacidadeDiariaCalculada}} mensagens por dia
                  </small>
                </div>
                <div class="protecao-linha protecao-linha-horario">
                  <span class="protecao-rotulo">
                    <i class="fas fa-receipt" aria-hidden="true"></i>
                    Mensagens de pedidos
                  </span>
                  <strong>{{numero.intervaloStatusPedidoSegundos === 60 ? '1 msg por minuto' : '1 msg a cada ' + formateDuracao(numero.intervaloStatusPedidoSegundos)}}</strong>
                  <small>{{numero.aplicarIntervaloConfirmacaoLoja ? 'Confirmações da loja online incluídas no intervalo.' : 'Confirmações da loja online fora do intervalo.'}}</small>
                  <small>Fora do limite diário e do horário de marketing.</small>
                </div>
              </div>
            </ng-container>

            <div class="protecao-aviso" *ngIf="numero.politicaCarregada && numero.versaoExtensao !== 4">
              <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
              <div>
                <strong>Este número está sem limite de envio</strong>
                <p>Toda campanha sai inteira no disparo. Com a nova extensão ela sai aos poucos: um limite por dia, no horário que você definir, continuando nos dias seguintes até terminar.</p>
              </div>
            </div>

            <div class="protecao-erro" *ngIf="numero.politicaErro">
              <i class="fas fa-exclamation-circle"></i>
              Não foi possível carregar a configuração deste número.
            </div>
          </div>
        </div>
        <footer class="numero-rodape">
          <span class="numero-versao" *ngIf="numero.politicaCarregada">
            <i class="fab fa-whatsapp" aria-hidden="true"></i> WhatsApp
            <a class="versao-link" [class.versao-nova]="numero.versaoExtensao === 4" [href]="extensaoDoNumero(numero).url" target="_blank" rel="noopener noreferrer"
               [title]="'Instalar ' + extensaoDoNumero(numero).nome + ' na Chrome Web Store'">{{extensaoDoNumero(numero).rotulo}}<i class="fas fa-external-link-alt" aria-hidden="true"></i></a>
          </span>
          <button type="button" class="btn-ajustar" (click)="editar(numero)" [attr.aria-label]="'Ajustar envios de ' + (numero.whatsapp | tel)">
            <i class="fas fa-sliders-h" aria-hidden="true"></i> Ajustar envios
          </button>
        </footer>
      </div>
    </div>

    <div class="regra-global" *ngIf="objetos.length > 0">
      <i class="fas fa-receipt" aria-hidden="true"></i>
      <div>
        <strong>Na nova extensão, mensagens de pedidos não entram no limite diário</strong>
        <span>Status do pedido e avaliações de pedidos seguem ritmos automáticos próprios.</span>
      </div>
    </div>

    <!-- Estado vazio -->
    <div class="estado-vazio" *ngIf="objetos.length === 0">
      <div class="estado-vazio-icone">
        <i class="fab fa-whatsapp"></i>
      </div>
      <h5>Nenhum número cadastrado</h5>
      <p>Cadastre o WhatsApp da sua loja para começar a atender os clientes e disparar campanhas.</p>
      <button class="btn-add-modern" (click)="novo()">
        <i class="fe-plus"></i>
        <span>Adicionar Número</span>
      </button>
    </div>

    <!-- Legenda -->
    <div class="legenda" *ngIf="objetos.length > 0">
      <div class="legenda-item">
        <i class="fas fa-crown legenda-icone icone-principal"></i>
        <span><strong>Atendimento:</strong> atende os clientes e assume as campanhas quando não há número específico.</span>
      </div>
      <div class="legenda-item">
        <i class="fas fa-bullhorn legenda-icone icone-campanhas"></i>
        <span><strong>Campanhas:</strong> clique para definir ou remover. Sem escolha, o principal é usado.</span>
      </div>
      <div class="legenda-item">
        <i class="fas fa-eye-slash legenda-icone icone-oculto"></i>
        <span><strong>Oculto:</strong> não aparece no cardápio público, serve apenas para uso interno.</span>
      </div>
    </div>
  </div>
</div>

<kendo-dialog title="Confirmar a remoção" *ngIf="modalDeletar" (close)="close('cancel')" [minWidth]="250" [width]="450">
  <p style="margin: 30px; text-align: center;">Você tem certeza que deseja remover o número WhatsApp <strong>{{objetoApagar.whatsapp}}</strong>?</p>
  <kendo-dialog-actions>
    <button kendoButton (click)="close('sim')" [primary]="true">Sim</button>
    <button kendoButton (click)="close('nao')">Não</button>
  </kendo-dialog-actions>
</kendo-dialog>
